// let HHDZModel = module.exports = {};
export default `
    <!doctype html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport"
          content="width=device-width, user-scalable=1, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
    <meta http-equiv="X-UA-Compatible" content="ie=edge">
    <title>活动</title>
    <style>
        .div{
            display: block;
        }
        body {
            padding: 0;
            margin: 0;
            background-color: #313891;
            font-size: 12px;
            color: #fff;
            /*max-width: 100%; !*最大宽度不超过 800 像素*!*/
        }

        .hd-title {
            text-align: center;
        }

        .text {
            color: #fdfdfd;
        }

        .main-box {
            padding: 0 12px;
        }

        table,
        th,
        td {
            border: 1px solid #318DD6;
        }

        table {
            border-collapse: collapse;
            max-width: 100%;
        }

        th {
            line-height: 30px;
        }

        th,
        td {
            text-align: center;
        }

        th {
            background: #318DD6;
            color: #000;
        }

        td {
            color: #fdfdfd;
        }

        .title {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
        }

        .but {
            background: linear-gradient(#2ad6fd, #0088fe);
            width: 200px;
            height: 42px;
            border-radius: 42px;
            line-height: 42px;
            font-size: 18px;
            font-weight: 400;
            text-align: center;
            margin: 0 auto;
            color: #fff;
        }
    </style>
    <style>.vfinder-info a,
    .vfinder-info div {
        color: #dedede;
    }

    .vfinder-info *,
    .vfinder-code * {
        margin: 0;
        padding: 0;
        border-width: 0;
        background: transparent;
    }

    .vfinder-info > div {
        padding: 4px 12px;
    }

    .vfinder-info > div:hover {
        background: rgba(140, 140, 140, 0.36);
    }

    .vfinder-info {
        position: fixed;
        border-radius: 4px;
        padding: 5px 0;
        background: rgba(64, 64, 64, 0.9);

        /*    padding: 10px 18px;*/
        z-index: 9999999;
        border: 1px solid rgb(143, 143, 143);
        font-size: 13px;
    }

    .vfinder-info:after {
        position: absolute;
        content: " ";
        width: 10px;
        height: 10px;
        -webkit-transform: rotate(45deg);
        background: rgba(64, 64, 64, 0.9);
        left: -5px;
        top: 50%;
        margin-top: -5px;
    }

    .vfinder-info-name-template {
        color: #ff7474;
    }

    .vfinder-info-name-style {
        color: #17ceff;
    }

    .vfinder-info-name-script {
        color: #f281ff;
    }

    .vfinder-info-name-created {
        color: #40c22a;
    }

    .vfinder-info-name-template,
    .vfinder-info-name-style,
    .vfinder-info-name-script,
    .vfinder-info-name-created {
        display: inline-block;
        width: 75px;
    }

    .vfinder-mask {
        position: fixed;
        z-index: 9999998;
        background-color: #588DE1;
        pointer-events: none;
    }

    .vfinder-code {
        position: fixed;
        /*    padding: 10px;*/
        /*    background: rgba(254, 255, 221, 0.9);*/
        background: rgba(64, 64, 64, 0.9);
        max-width: 400px;
        font-size: 10px;
        z-index: 10000000;
        word-wrap: break-word;
        border-radius: 4px;
        /*    color: #747474;*/
        color: #dedede;
        border: 1px solid rgba(222, 222, 222, 0.34);
    }

    .vfinder-path::-webkit-scrollbar,
    .vfinder-code-content::-webkit-scrollbar {
        height: 8px;
        width: 8px;
    }

    .vfinder-path::-webkit-scrollbar-thumb,
    .vfinder-code-content::-webkit-scrollbar-thumb {
        background: rgba(103, 103, 103, 0.9);
        border-radius: 4px;
    }

    .vfinder-path::-webkit-scrollbar-track,
    .vfinder-code-content::-webkit-scrollbar-track {
        background: #ddd;
        border-radius: 4px;
    }


    .vfinder-code-content {
        padding: 0 10px;
        overflow: auto;
        max-height: 260px;
    }

    .vfinder-code-content p {
        padding: 2px 6px 2px 0;
    }

    .vfinder-code-content > pre {
        float: left;
        clear: left;
        white-space: nowrap;
    }

    .vfinder-current-code-line {
        background: rgba(234, 102, 223, 0.25);
        border-radius: 2px;
    }

    .vfinder-path {
        padding: 10px;
        border-bottom: 1px solid rgba(222, 222, 222, 0.34);
        background: rgba(140, 140, 140, 0.36);
        white-space: nowrap;
        overflow-x: auto;
    }

    .vfinder-line-count {
        color: #dedede;
        min-width: 25px;
        display: inline-block;
    }


    </style>
    <style>/*
  IR_Black style (c) Vasily Mikhailitchenko <vaskas@programica.ru>
*/

    .hljs {
        display: block;
        overflow-x: auto;
        padding: 0.5em;
        background: #000;
        color: #f8f8f8;
    }

    .hljs-comment,
    .hljs-quote,
    .hljs-meta {
        color: #7c7c7c;
    }

    .hljs-keyword,
    .hljs-selector-tag,
    .hljs-tag,
    .hljs-name {
        color: #96cbfe;
    }

    .hljs-attribute,
    .hljs-selector-id {
        color: #ffffb6;
    }

    .hljs-string,
    .hljs-selector-attr,
    .hljs-selector-pseudo,
    .hljs-addition {
        color: #a8ff60;
    }

    .hljs-subst {
        color: #daefa3;
    }

    .hljs-regexp,
    .hljs-link {
        color: #e9c062;
    }

    .hljs-title,
    .hljs-section,
    .hljs-type,
    .hljs-doctag {
        color: #ffffb6;
    }

    .hljs-symbol,
    .hljs-bullet,
    .hljs-variable,
    .hljs-template-variable,
    .hljs-literal {
        color: #c6c5fe;
    }

    .hljs-number,
    .hljs-deletion {
        color: #ff73fd;
    }

    .hljs-emphasis {
        font-style: italic;
    }

    .hljs-strong {
        font-weight: bold;
    }
    img{
        max-width:100vw;
    }
    </style>
</head>
<body>
<!--body下 必须用一个 class为aff的div包裹起来，以方便APP那边计算网页高度-->
<div class="aff">
`
